import Axios from "axios"
import qs from 'qs'

import config from "./config"
let url = config.url; 

// 三级联动
export function area(module) {
  const data = {
    m: 'graduationApi',
    t: "areaApi",
    c: "area",
    area_code: module.area_code
  };
  return Axios.get(url, { params: data }).then(res => {
    return Promise.resolve(res.data)
  })
}

//完善个人信息
export function insertPersonal(module) {
  const data = qs.stringify( {
    m:"studentEnrollApi", 
    t:"studentEnrollApi", 
    c:"insertPersonal", 
    sfzjh:module.sfzjh, 
    xm:module.xm, 
    xbm:module.xbm, 
    lydq:module.lydq, 
    mobile:module.mobile, 
    txdz:module.txdz, 
  }); 
  return Axios.post(url, data).then(res =>  {
    return Promise.resolve(res.data)
  })
}

//上传照片接口
export function uploadImg(module) {
  return Axios.post(url + '?m=studentEnrollApi&t=studentEnrollApi&c=upload', module.file).then(res =>  {
    return Promise.resolve(res.data)
  })
}


//个人信息完善接口
export function finishPersonInfo(module) {

  const data = qs.stringify( {
    m:"studentEnrollApi", 
    t:"studentEnrollApi", 
    c:"insertPersonal", 
    sfzjh:module.sfzjh, 
    xm:module.xm, 
    batch_id:module.batch_id, 
    xbm:module.xbm, 
    lydqdm: module.lydqdm, 
    mobile:module.mobile, 
    txdz:module.txdz, 
    jg:module.jg, 
    csrq:module.csrq, 
    postal_code:module.postal_code, 
    sjr:module.sjr, 
    mzm:module.mzm, 
    resource_id:module.resource_id, 
    zzmmm:module.zzmmm, 
    state: module.state, //报名类型
    provinceCode: module.provinceCode,//三级联动
    cityCode: module.cityCode ,
    kh: module.kh,
    xzm: module.xzm
    
  }); 
  return Axios.post(url, data).then(res =>  {
    return Promise.resolve(res.data)
  })
}

//报名信息完善接口
export function finishEnrollData(module) {
  const data = qs.stringify( {
    m:"studentEnrollApi", 
    t:"studentEnrollApi", 
    c:"insertEnrollData", 
    // 基本信息
    sfzjh:module.sfzjh, 
    xm:module.xm, 
    batch_id:module.batch_id, 

    //专业信息，id和名称
    zyid:module.zyid, //志愿
    xz:module.xzm, //学制
    klm: module.klm

  }); 
  return Axios.post(url, data).then(res =>  {
    return Promise.resolve(res.data)
  })
}

//录取查询接口
export function admitSearch(module) {
  const data = qs.stringify( {
    m:"studentEnrollApi", 
    t:"studentEnrollApi", 
    c:"admitSearch", 
    sfzjh:module.sfzjh, 
    xm:module.xm, 
  }); 
  return Axios.post(url, data).then(res =>  {
    return Promise.resolve(res.data)
  })
}

//获取准考证信息
export function examCard(module) {
  const data =  {
    m:"studentEnrollApi", 
    t:"studentEnrollApi", 
    c:"examCard", 
    sfzjh:module.sfzjh, 
    sch_id:module.sch_id, 
     batch_id:module.batch_id
  }; 
  return Axios.get(url,  {params:data}).then(res =>  {
    return Promise.resolve(res.data)
  })
}

//获取成绩接口
export function scoreSearch(module) {
  const data = qs.stringify( {
    m:"studentEnrollApi", 
    t:"studentEnrollApi", 
    c:"scoreSearch", 
    sfzjh:module.sfzjh, 
    xm:module.xm, 
    batch_id:module.batch_id, 
  }); 
  return Axios.post(url, data).then(res =>  {
    return Promise.resolve(res.data)
  })
}

//获取学制、专业
export function getMajor(module) {
  const data = qs.stringify( {
    m:"studentEnrollApi", 
    t:"studentEnrollApi", 
    c:"getMajorAjax", 
    xzm:module.xzm, 
    sch_id:module.sch_id,
    year: module.year

  }); 
  return Axios.post(url, data).then(res =>  {
    return Promise.resolve(res.data)
  })
}

//获取个人信息
export function personal(module) {
  const data = qs.stringify( {
    sfzjh:module.sfzjh, 
    xm:module.xm, 
    batch_id:module.batch_id, 
  }); 
  return Axios.post(url + '?m=studentEnrollApi&t=studentEnrollApi&c=personal', data).then(res =>  {
    return Promise.resolve(res.data)
  })
}

//获取报名信息
export function personalEnroll(module) {
  const data = qs.stringify( {
    m:"studentEnrollApi", 
    t:"studentEnrollApi", 
    c:"personalEnroll", 
    sfzjh:module.sfzjh, 
    xm:module.xm, 
    batch_id:module.batch_id, 
  }); 
  return Axios.post(url, data).then(res =>  {
    return Promise.resolve(res.data)
  })
}



// WEBPACK FOOTER //
// ./src/api/updata.js